import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-text-center h-mb-20" }
const _hoisted_2 = { class: "b-base-title h-mt-10" }
const _hoisted_3 = { class: "b-text-error h-text-center h-fw-500" }
const _hoisted_4 = { class: "h-flex h-flex-center h-width-100p" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwInput = _resolveComponent("FwInput")!
  const _component_FwFormInput = _resolveComponent("FwFormInput")!
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('AUTH.CONFIRM_ACCOUNT.TITLE')), 1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("form", {
        class: "h-mt-15",
        onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.sendDataToServer && _ctx.sendDataToServer(...args)), ["enter"]))
      }, [
        _createVNode(_component_FwFormInput, {
          class: "h-mb-25",
          fieldHasError: _ctx.fieldHasErrorByRule(_ctx.email, _ctx.EMAIL, _ctx.emailRules),
          labelType: "label-thin",
          title: _ctx.$t(`AUTH.SIGN_UP.FORM.EMAIL.LABEL`)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FwInput, {
              value: _ctx.email,
              type: "text",
              name: "text",
              inputStyle: "gray",
              placeholder: "adresse@email.com",
              error: _ctx.getFieldErrorTextByRule(_ctx.email, _ctx.EMAIL, _ctx.emailRules),
              onUpdate: _cache[0] || (_cache[0] = value => _ctx.email = value),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearServerErrorsBase(_ctx.EMAIL))),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addCurrentInputToValidateArray(_ctx.EMAIL)))
            }, null, 8, ["value", "error"])
          ]),
          _: 1
        }, 8, ["fieldHasError", "title"]),
        _createVNode(_component_FwFormInput, {
          class: "h-mb-25",
          fieldHasError: _ctx.fieldHasErrorByRule(_ctx.token, _ctx.TOKEN, _ctx.tokenRules),
          labelType: "label-thin",
          title: _ctx.$t(`AUTH.SIGN_UP.FORM.EMAIL_CODE.LABEL`)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FwInput, {
              value: _ctx.token,
              type: "tel",
              name: "code",
              placeholder: _ctx.$t(`AUTH.SIGN_UP.FORM.EMAIL_CODE.PLACEHOLDER`),
              inputStyle: "gray",
              error: _ctx.getFieldErrorTextByRule(_ctx.token, _ctx.TOKEN, _ctx.tokenRules),
              onUpdate: _cache[3] || (_cache[3] = value => _ctx.token = value),
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clearServerErrorsBase(_ctx.TOKEN))),
              onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addCurrentInputToValidateArray(_ctx.TOKEN)))
            }, null, 8, ["value", "placeholder", "error"])
          ]),
          _: 1
        }, 8, ["fieldHasError", "title"])
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.globalServerError), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_FwButton, {
        class: "h-mt-30",
        disabled: !_ctx.isFormValid,
        borderRadiusType: "small-border",
        onClick: _ctx.sendDataToServer
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('AUTH.SIGN_UP.FORM.BUTTON.NEXT')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _createVNode(_component_router_link, {
      to: { name: "LoginPage" },
      class: "b-url-with-arrow h-mt-20"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('AUTH.LOGIN.LINK_TEXT')) + " ", 1),
        _createVNode(_component_FwIcon, {
          class: "h-ml-15 b-url-with-arrow__icon",
          icon: "arrow-right",
          size: "10",
          color: "#BEC7D3"
        })
      ]),
      _: 1
    })
  ]))
}